<template>
  <section id="about" class="about-wrap style1 pt-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-right"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="about-img-wrap">
            <img
              class="about-img-one"
              src="../../assets/images/about/about-img-1.jpg"
              alt="Image"
            />
            <img
              class="about-img-two"
              src="../../assets/images/about/about-img-2.jpg"
              alt="Image"
            />
            <div class="about-promo-text">
              <h5><span>30+</span> Years Of Experience</h5>
            </div>
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="about-content">
            <div class="content-title style1">
              <span>Get To Know Us</span>
              <h2>We Have An Easy Solution For Your Dental Problems</h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem has standard dummy text ever since the 1500s,
                when an unknown.
              </p>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content when looking at its layout. The point of
                using Lorem Ipsum is that amet has a moreorless normal
                distribution of letters as opposed dolor.
              </p>
            </div>
            <ul class="content-feature-list list-style style3">
              <li>
                <span><i class="ri-check-double-line"></i></span>Stop worrying,
                we will take care of your physical problems
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>Challenges with
                dental insurance can take valuable time
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>Dental
                insurance issues are the most important that dentists face
              </li>
            </ul>
            <div class="about-subtext">
              <span>
                <img
                  src="../../assets/images/icons/medical-team.svg"
                  alt="Image"
                />
              </span>
              <h5>
                Being a good boss and following the rules are the keys to a
                successful dental team
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "EasySolution",
};
</script>